// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Analytics Sidebar */
.analytics-sidebar {
  position: fixed;
  right: 0;
  top: 10px;
  height: calc(100vh - 40px);
  width: 60px; /* Collapsed width */
  background-color: #f4f4f4;
  transition: width 0.3s ease; /* Smooth transition */
  overflow: hidden;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px; /* Adjusted padding for logo positioning */
  border-radius: 10px;
}

/* Expanded Sidebar on Hover */
.analytics-sidebar:hover {
  width: 240px; /* Expanded width */
}

/* Sidebar Items */
.analytics-sidebar ul {
  list-style: none;
  padding: 0;
  margin-top: 20px; /* Adjust margin to align icons properly */
  width: 100%; /* Ensure icons align with sidebar width */
}

/* Sidebar List Items */
.analytics-sidebar li {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: start; /* Align text and icon horizontally */
  cursor: pointer;
  transition: background-color 0.3s ease;
}

/* Highlight List Item on Hover */
.analytics-sidebar li:hover {
  background-color: #e0e0e0;
}

/* Sidebar Icons */
.sidebar-icon {
  font-size: 24px; /* Increased icon size for visibility */
  margin-right: 10px; /* Space between icon and text */
  transition: opacity 0.2s ease; /* Smooth icon appearance */
  opacity: 1;
}

/* Sidebar Text */
.sidebar-text {
  opacity: 0; /* Hide text when collapsed */
  transition: opacity 0.2s ease-in-out, visibility 0s linear 0.3s;
  white-space: nowrap; /* Prevent text wrapping */
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 10px; /* Add space between icon and text */
}

/* Show text on hover */
.analytics-sidebar:hover .sidebar-text {
  opacity: 1; /* Show text instantly when expanded */
  transition-delay: 0s; /* Remove additional delay */
  visibility: visible;
}

.analytics-sidebar li.active {
  background-color: #d0d0d0; /* Highlight color */
  font-weight: bold;
  color: #333; /* Change text color for visibility */
}

/* Sidebar Logo Section */
.sidebar-logo {
  width: 100%;
  padding: 10px 0; /* Adjust padding to align the logo */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f4f4f4; /* Same as sidebar background */
  border-bottom: 1px solid #ddd; /* Optional: Separator line */
  margin-bottom: 10px;
}

/* Adjust Logo Image */
.analytics-logo {
  max-width: 85%; 
  height: auto;
  object-fit: contain; /* Ensure proper scaling */
  background-color: #f4f4f4;
  padding: 5px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05); /* Subtle shadow */
}
`, "",{"version":3,"sources":["webpack://./src/analytics/analyticsSidebar.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,WAAW,EAAE,oBAAoB;EACjC,yBAAyB;EACzB,2BAA2B,EAAE,sBAAsB;EACnD,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB,EAAE,0CAA0C;EAC7D,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,YAAY,EAAE,mBAAmB;AACnC;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB,EAAE,0CAA0C;EAC5D,WAAW,EAAE,0CAA0C;AACzD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB,EAAE,qCAAqC;EAC7D,eAAe;EACf,sCAAsC;AACxC;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,eAAe,EAAE,uCAAuC;EACxD,kBAAkB,EAAE,gCAAgC;EACpD,6BAA6B,EAAE,2BAA2B;EAC1D,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,UAAU,EAAE,6BAA6B;EACzC,+DAA+D;EAC/D,mBAAmB,EAAE,0BAA0B;EAC/C,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB,EAAE,oCAAoC;AACzD;;AAEA,uBAAuB;AACvB;EACE,UAAU,EAAE,sCAAsC;EAClD,oBAAoB,EAAE,4BAA4B;EAClD,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,iBAAiB;EACjB,WAAW,EAAE,qCAAqC;AACpD;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,eAAe,EAAE,qCAAqC;EACtD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB,EAAE,+BAA+B;EAC1D,6BAA6B,EAAE,6BAA6B;EAC5D,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB,EAAE,0BAA0B;EAC/C,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,4CAA4C,EAAE,kBAAkB;AAClE","sourcesContent":["/* Analytics Sidebar */\r\n.analytics-sidebar {\r\n  position: fixed;\r\n  right: 0;\r\n  top: 10px;\r\n  height: calc(100vh - 40px);\r\n  width: 60px; /* Collapsed width */\r\n  background-color: #f4f4f4;\r\n  transition: width 0.3s ease; /* Smooth transition */\r\n  overflow: hidden;\r\n  z-index: 9999;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding-top: 20px; /* Adjusted padding for logo positioning */\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Expanded Sidebar on Hover */\r\n.analytics-sidebar:hover {\r\n  width: 240px; /* Expanded width */\r\n}\r\n\r\n/* Sidebar Items */\r\n.analytics-sidebar ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin-top: 20px; /* Adjust margin to align icons properly */\r\n  width: 100%; /* Ensure icons align with sidebar width */\r\n}\r\n\r\n/* Sidebar List Items */\r\n.analytics-sidebar li {\r\n  padding: 15px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: start; /* Align text and icon horizontally */\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n/* Highlight List Item on Hover */\r\n.analytics-sidebar li:hover {\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n/* Sidebar Icons */\r\n.sidebar-icon {\r\n  font-size: 24px; /* Increased icon size for visibility */\r\n  margin-right: 10px; /* Space between icon and text */\r\n  transition: opacity 0.2s ease; /* Smooth icon appearance */\r\n  opacity: 1;\r\n}\r\n\r\n/* Sidebar Text */\r\n.sidebar-text {\r\n  opacity: 0; /* Hide text when collapsed */\r\n  transition: opacity 0.2s ease-in-out, visibility 0s linear 0.3s;\r\n  white-space: nowrap; /* Prevent text wrapping */\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  margin-left: 10px; /* Add space between icon and text */\r\n}\r\n\r\n/* Show text on hover */\r\n.analytics-sidebar:hover .sidebar-text {\r\n  opacity: 1; /* Show text instantly when expanded */\r\n  transition-delay: 0s; /* Remove additional delay */\r\n  visibility: visible;\r\n}\r\n\r\n.analytics-sidebar li.active {\r\n  background-color: #d0d0d0; /* Highlight color */\r\n  font-weight: bold;\r\n  color: #333; /* Change text color for visibility */\r\n}\r\n\r\n/* Sidebar Logo Section */\r\n.sidebar-logo {\r\n  width: 100%;\r\n  padding: 10px 0; /* Adjust padding to align the logo */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #f4f4f4; /* Same as sidebar background */\r\n  border-bottom: 1px solid #ddd; /* Optional: Separator line */\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Adjust Logo Image */\r\n.analytics-logo {\r\n  max-width: 85%; \r\n  height: auto;\r\n  object-fit: contain; /* Ensure proper scaling */\r\n  background-color: #f4f4f4;\r\n  padding: 5px;\r\n  border-radius: 8px;\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05); /* Subtle shadow */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
